<div class="wrapper">

  <div class="hotel-name">
    <span>
      {{images.name}}
    </span>
    <span class="close-btn" (click)="onClose()">
      <i class="fa fa-close"></i>
    </span>
  </div>

  <div class="image-view" [style.backgroundImage]="'url(' + activeBackground?.url + ')'">
    <span class="icon left-icon" (click)="prevImage()">
      <i class="fa fa-angle-left"></i>
    </span>
    <span class="icon right-icon" (click)="nextImage()">
      <i class="fa fa-angle-right"></i>
    </span>
  </div>

  <div class="image-carousel">
    <!-- <div class="hotel-count">
      {{images?.length}}
      <span class="circle-icon">
        <i class="fa fa-circle"></i>
      </span>
      Room View
    </div> -->
    <div class="image-items" id='image-items'>
      <div class="scroll-left arrow" (click)="scrollLeftRight('left')">
        <i class="fa fa-caret-left"></i>
      </div>
      <div class="image-item" #imageItem *ngFor="let image of images; let index = index">
        <img [src]="image.url" alt="" (click)="setActiveImage(index)" [ngClass]="{'active-img': index === activeBackgroundIndex}">
      </div>
      <div class="scroll-right arrow" (click)="scrollLeftRight('right')">
        <i class="fa fa-caret-right arrow"></i>
      </div>
    </div>
  </div>

</div>
